import { notifications } from '@mantine/notifications';

import {
  buildFormValues,
  fetchTemplateOrThrow,
  normalizeSteps,
  parseTemplateConfig,
  resetAndValidate,
} from '../shared';
import { type TemplateImportDependencies } from './types';

export function createTemplateImportHandler({
  experienceForm,
  selectedSessionType,
  setSelectedSessionType,
  setActiveStep,
  setExperienceConfigId,
  setIsExperienceFormDirty,
  onTemplateImported,
}: TemplateImportDependencies) {
  return async (templateId: string | number) => {
    try {
      const currentValues = experienceForm.getValues();
      const template = await fetchTemplateOrThrow(templateId);
      const parsed = parseTemplateConfig(template);

      const resolvedSessionType = template.sessionType ?? selectedSessionType;

      if (resolvedSessionType) {
        setSelectedSessionType(resolvedSessionType);
        setActiveStep(3);
      }

      const normalizedSteps = normalizeSteps(parsed.steps);

      const formValues = buildFormValues({
        template,
        config: parsed.config,
        normalizedSteps,
        currentValues,
      });

      await resetAndValidate(experienceForm, formValues);

      setExperienceConfigId(formValues.id || null);
      setIsExperienceFormDirty(false);

      // Call callback with template to populate modal fields
      if (onTemplateImported) {
        onTemplateImported(template);
      }

      notifications.show({
        color: 'green',
        title: 'Template importato',
        message: 'La configurazione è stata caricata nel form.',
      });
    } catch (error) {
      notifications.show({
        color: 'red',
        title: 'Errore',
        message:
          error instanceof Error
            ? error.message
            : "Errore durante l'importazione del template",
      });
      throw error;
    }
  };
}
